var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlimitedTemplates = function SvgUnlimitedTemplates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5258",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5258)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.265,
    cy: 55,
    r: 5.61224,
    transform: "rotate(-180 103.265 55)",
    fill: "#DFF2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.6326,
    cy: 89.796,
    r: 16.8367,
    transform: "rotate(-180 51.6326 89.796)",
    fill: "#FFF1B6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_1112_5258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6125 69.2747V92.3579C60.6115 93.6733 60.9185 94.9708 61.5091 96.1462L66.3833 90.7921L70.4115 86.3724C71.4975 85.1855 73.1264 84.3394 74.4902 84.8824C75.9637 85.7315 77.3546 86.7166 78.6447 87.8246L82.0794 84.0363C82.5162 83.5541 83.0492 83.1686 83.644 82.9048C84.2388 82.641 84.8823 82.5047 85.533 82.5047C86.1837 82.5047 86.8272 82.641 87.422 82.9048C88.0169 83.1686 88.5498 83.5541 88.9866 84.0363L95.2499 90.9184L100.086 96.2724C100.708 95.0618 101.029 93.7189 101.021 92.3579V69.2747C101.021 66.9773 100.108 64.774 98.4835 63.1494C96.859 61.5249 94.6556 60.6122 92.3582 60.6122H69.275C66.9776 60.6122 64.7743 61.5249 63.1497 63.1494C61.5252 64.774 60.6125 66.9773 60.6125 69.2747V69.2747Z",
    fill: "url(#paint0_linear_1112_5258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7347 95.9289C62.3299 97.1584 63.177 98.2476 64.2204 99.1251C65.2639 100.003 66.4802 100.648 67.7895 101.02L77.669 90.0291L80.8163 86.5544C79.4012 85.3143 77.8752 84.2081 76.2576 83.2499C74.7193 82.6401 72.8986 83.5903 71.6989 84.9235L67.1967 89.9156L61.7347 95.9289Z",
    fill: "url(#paint1_linear_1112_5258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.926 100.705C67.6829 100.914 68.4644 101.02 69.2495 101.02H92.3579C93.9593 101.022 95.5297 100.579 96.8942 99.7406C98.2586 98.9023 99.3636 97.7017 100.086 96.2724L95.2496 90.9184L88.999 84.049C88.5622 83.5667 88.0292 83.1812 87.4344 82.9174C86.8395 82.6536 86.196 82.5173 85.5453 82.5173C84.8946 82.5173 84.2512 82.6536 83.6563 82.9174C83.0615 83.1812 82.5285 83.5667 82.0917 84.049L78.657 87.8372L75.8411 90.9184L66.926 100.705Z",
    fill: "url(#paint2_linear_1112_5258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.347 100.714C68.0899 100.917 68.857 101.02 69.6278 101.02H92.3118C93.8838 101.022 95.4254 100.592 96.7648 99.7782C98.1042 98.9645 99.1889 97.7992 99.898 96.412L95.1504 91.2153L89.0146 84.5478C88.5858 84.0797 88.0626 83.7056 87.4787 83.4495C86.8948 83.1935 86.2631 83.0612 85.6244 83.0612C84.9856 83.0612 84.354 83.1935 83.77 83.4495C83.1861 83.7056 82.6629 84.0797 82.2342 84.5478L78.8625 88.2247L76.0983 91.2153L67.347 100.714Z",
    fill: "url(#paint3_linear_1112_5258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7143 74.0816C68.8546 74.0816 67.3469 72.574 67.3469 70.7143C67.3469 68.8545 68.8546 67.3469 70.7143 67.3469C72.574 67.3469 74.0816 68.8545 74.0816 70.7143C74.0816 72.574 72.574 74.0816 70.7143 74.0816Z",
    fill: "url(#paint4_linear_1112_5258)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5258",
    x1: 80.8166,
    y1: 96.2724,
    x2: 80.8166,
    y2: 60.6122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5258",
    x1: 61.7347,
    y1: 83.0612,
    x2: 80.8163,
    y2: 83.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5258",
    x1: 66.926,
    y1: 82.5173,
    x2: 100.086,
    y2: 82.5173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1112_5258",
    x1: 67.347,
    y1: 83.0612,
    x2: 99.898,
    y2: 83.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1112_5258",
    x1: 67.3469,
    y1: 67.3469,
    x2: 74.0816,
    y2: 67.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_5258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4082,
    height: 40.4082,
    fill: "white",
    transform: "matrix(-1 0 0 1 101.02 60.6122)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlimitedTemplates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlimited-templates.42e5224d3e9626c8e80d10779a8ff694.svg";